module.exports = {
    "small": 660,
    "medium": 768,
    "large": 1200,
    "menu": 1250,
    "xLarge": 1390,
    "xxLarge": 1500,
    "wide": 2100
}